import { createContext } from 'react';

import {
  GetTokenSilentlyOptions,
  BaseLoginOptions,
  LogoutOptions,
  GetTokenWithPopupOptions,
  PopupConfigOptions,
} from '@auth0/auth0-spa-js';

import { ExtendedPopupLoginOptions } from './AuthProvider';
import { User } from './AuthState';
import { AuthState, initialAuthState } from './AuthState';

export type AuthMode = 'login' | 'signUp' | 'forgotPassword';

export interface RedirectLoginOptions extends BaseLoginOptions {
  redirectUri?: string;
  isDirectUrl?: boolean;
  appState?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  fragment?: string;
  mode?: AuthMode;
}

export interface AuthContextInterface extends AuthState {
  getAccessTokenSilently: (options?: GetTokenSilentlyOptions) => Promise<string>;
  getAccessTokenWithPopup: (
    options?: GetTokenWithPopupOptions,
    config?: PopupConfigOptions,
  ) => Promise<string>;

  loginWithRedirect: (options?: RedirectLoginOptions) => Promise<void>;
  loginWithPopup: (
    options?: ExtendedPopupLoginOptions,
    config?: PopupConfigOptions,
  ) => Promise<void>;

  logout: (options?: LogoutOptions) => void;
  updateUserInfo: (user: User) => void;
}

const stub = (): never => {
  throw new Error('You forgot to wrap your component in <AuthProvider>.');
};

const initialContext = {
  ...initialAuthState,
  getAccessTokenSilently: stub,
  getAccessTokenWithPopup: stub,
  loginWithRedirect: stub,
  loginWithPopup: stub,
  logout: stub,
  updateUserInfo: stub,
};

export const AuthContext = createContext<AuthContextInterface>(initialContext);
